module.exports = __webpack_public_path__ + "assets/efea2dfc0ec6c0affd72db32dce319ab.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/fonts/freeplay.svg
// module id = ./src/styles/icons/fonts/freeplay.svg
// module chunks = 0